import { ISelectOption } from 'components/forms/Selects'
import { IMotorCarrierInfoFragment } from '../graphql/MotorCarrierInfoFragment'

export function getMotorCarrierSelectOptions(
  carriers: IMotorCarrierInfoFragment[]
): ISelectOption[] {
  return carriers.map(c => {
    const { id, legalName } = c || {}
    const option = {
      label: legalName ?? '',
      value: id,
    }
    return option
  })
}
